import { createSelector } from '@ngrx/store';
import { CampaignContentState } from '../models/campaign-models';
import {CampaignSettingsState} from "../models/assessment-models";

export const selectCampaignContentState = (state: any): CampaignContentState => state.getCampaignContent;

export const selectCampaignContentByKey = (key: string) =>
  createSelector(selectCampaignContentState, (state) => {
    const item = state.content.find((i) => i.key === key);
    return item?.value || null;
  });

export const selectCampaignSettingsState = (state: any): CampaignSettingsState  => state.getCampaignSettings;

export const selectCampaignSettingsShowExternalIdField = createSelector(
  selectCampaignSettingsState,
  (state) => state.showExternalIdField
);
